import type { ProjectHealth, ProjectStage } from '../../shared/types';

export const stageLabels: Record<ProjectStage, string> = {
  discovery: 'Discovery',
  specification: 'Specification',
  build: 'Build',
  validation: 'Validation',
  shipped: 'Shipped',
  maintenance: 'Maintenance',
  on_hold: 'On hold',
  archived: 'Archived',
};

export const healthLabels: Record<ProjectHealth, string> = {
  on_track: 'On track',
  at_risk: 'At risk',
  blocked: 'Blocked',
};

export function relativeTime(value: string) {
  const delta = Date.now() - new Date(value).getTime();
  const days = Math.floor(delta / 86_400_000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return `${months} ${months === 1 ? 'month' : 'months'} ago`;
}

export function bytes(value: number) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / 1024 / 1024).toFixed(1)} MB`;
}
